import React from "react";
import { cloneDeep } from "lodash";
import {
  ResultComparison,
  ScaleComponent,
  //GelDragDrop,
  RenderTubeImage
} from "@learningblocks/storybook-components";
import "./style.scss";
//import { actualLaneData, emptyLane } from "./actualLaneData";

export class ResultsComparisonPhotosynthesis extends React.Component {

  renderOption = (option, key) => (
        <RenderTubeImage {...option.optionTube} />
  );

  renderOptions = (options, altText) => (
    <div className='colorSelectWidget_options' aria-label={altText}>
      {options.map(this.renderOption)}
    </div>
  );

  getSolutionColor = (solutions) => {

    if(solutions !== null && typeof solutions !== 'undefined'){
      let pH = 0;
      let volume = 0;

      for(var sol in solutions){
        volume =+ solutions[sol].volume;
        pH =+ solutions[sol].pH;
      }

      pH = pH / Object.keys(solutions).length;

      let pHLookup = {
        "-1": 'red',
        "2": "rgb(246, 205, 15)",
        "6": "rgb(209, 185, 61)",
        "6.1": "rgb(212, 184, 41)",
        "6.3": "rgb(194, 184, 48)",
        "6.5": "rgb(154, 173, 58)",
        "6.7": "rgb(119, 145, 59)",
        "6.9": "rgb(85, 119, 54)",
        "7.1": "rgb(48, 89, 60)",
        "7.3": "rgb(1, 61, 70)",
        "7.5": "rgb(23, 35, 77)",
        "7.7": "rgb(26, 37, 83)",
        "7.9": "rgb(32, 39, 91)",
        "8.0": "rgb(3, 31, 92)",
        "12": "rgb(43, 45, 123)"
      }

      let match = Object.keys(pHLookup).reduce((a, b) => {
        return Math.abs(parseFloat(b) - parseFloat(pH)) < Math.abs(parseFloat(a) - parseFloat(pH)) ? b : a;
      })

      if(Object.keys(solutions).includes('BTB')){
        return pHLookup[match];
      } else {
        return "#66cef5"
      }
    }

  }

  generateAltText = (data) => {
    let altString = '';
   
   for (let i = 0; i < data.length; i++) {
    const tube = data[i].optionTube;
    altString = altString + `Tube ${tube.tubeLabel} is ${(tube.hasOwnProperty('boxId') && tube.boxId != -1)? 'in a box': 'not in a box'}. It ${(tube.hasOwnProperty('plantId') && tube.plantId != -1)? 'has a water plant in it': 'doesn’t have a water plant in it'} The BTB solution is ${this.getSolutionColourLabel(tube.solution)} (pH ${this.getSolutionPh(tube.solution)}).\n`;
   }

   return altString;
  }

  getSolutionColourLabel = (colour) => {
    switch (colour) {
      case "rgb(85, 119, 54)":
      case "#4a663c":
        return 'green';

      case "#041f5c":
        return 'blue';

      case "#d1b93d":
        return 'yellow';

      default:
        return colour;
    }
  }

  getSolutionPh = (colour) => {
    switch (colour) {
      case "rgb(85, 119, 54)":
      case "#4a663c":
        return '6.9';

      case "#041f5c":
        return '8';

      case "#d1b93d":
        return '6';

      default:
        return colour;
    }
  }

  getPredictedGel = () => {
    let data = cloneDeep(this.props.colorPrediction.options);
    let altText = this.generateAltText(data);
    return this.renderOptions(data, altText);
  };

  getActualGel = () => {
    let data = cloneDeep(this.props.interactionProps.glassTubes).map(
      (tube) => {
        tube.type = "GLASS_TUBE"
        tube.solution = this.getSolutionColor(tube.solutions)
        tube.stopperId = tube.stopperIdBackup
        tube.plantId = tube.plantIdBackup
        tube.boxId = tube.boxIdBackup
        return { optionTube: tube }
      }
    );
    let altText = this.generateAltText(data);
    return this.renderOptions(data, altText);
  };

  getIdealGel = () => {
    let data = cloneDeep(this.props.idealData);
    let altText = this.generateAltText(data);
    return this.renderOptions(data, altText);
  };

  render() {
    return (
      <ResultComparison
        predictedState={{
          type: "component",
          component: (
            <>
              <p>These are your initial predictions:</p>
              {this.getPredictedGel()}
            </>
          ),
        }}
        actualState={{
          type: "component",
          component: (
            <>
              <p>These are your actual results:</p>
              {this.getActualGel()}
            </>
          ),
        }}
        idealState={{
          type: "component",
          component: (
            <>
              <p>These are your ideal results:</p>
              {this.getIdealGel()}
            </>
          ),
        }}
      />
    );
  }
}
